import { AsButton, AsText, useModal, IconClose, getClaimValue, AsLabel } from '@adserve/adserve-react-components';
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { CampaignsLookup, CategoriesLookup, DemographicsLookup, UsersLookup } from '../components/Campaign/CampaignBrief/CampaignBriefLookupService';
import { compactTableInputStyle } from '../components/Campaign/CampaignBrief/CampaignBriefStyles';
import CampaignCompactTableColumnDefinitions from '../components/Campaign/CampaignBrief/ColumnDefinitions/CampaignCompactTableColumnDefinitions';
import UserCompactTableColumnDefinitions from '../components/Campaign/CampaignBrief/ColumnDefinitions/UserCompactTableColumnDefinitions';
import AsSelectWithPlaceholder from '../components/generic/AsSelectWithPlaceholder';
import AsTextarea from '../components/generic/AsTextArea';
import CompactTable from '../components/generic/CompactTable/CompactTableNew';
import EntityMatcher from '../components/generic/EntityMatcher/EntityMatcher';
import FileUploadButton from '../components/generic/FileUploadButton';
import { Get, GetAccountById } from '../services/CampaignsDataService';
import { GetAll, GetBaseDemographic, GetExternalSource } from '../services/DataService';
import { accountSearch, getMapping, importRict, validate } from '../services/JetService';
import { inputStyle } from '../styles';
import { ReactComponent as IconArrow } from '../svg/icon_ExtArrow.svg';

const panelStyle = {
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    border: '1px solid #D7D7D7',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    marginBottom: 10,
    paddingTop: 20,
    paddingBottom: 20
};

const iconStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '15%'
};

const labelStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '10%',
    textAlign: 'unset',
    marginRight: 15,
    fontSize: 12
};

const lookupLabelStyle = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: 12,
    marginBottom: 5
};

const rowStyle = {
    display: 'flex',
    width: '100%',
    marginBottom: 10
};

const buttonStyle = {
    fontSize: 15,
    width: 120
};

const pageInputStyle = {
    ...inputStyle,
    width: '50%'
}

const JetImportPage = () => {
    const { addMessage } = useModal();
    const history = useHistory();

    const [rictFile, setRictFile] = useState();
    const [rictFileInfo, setRictFileInfo] = useState();
    const [campaignInfo, setCampaignInfo] = useState({});
    const [readOnly, setReadOnly] = useState(true);
    const [isJetFileUpload, setIsJetFileUpload] = useState(true);
    const [validationMessage, setValidationMessage] = useState();
    const [revenueTypes, setRevenueTypes] = useState([]);
    const [isCreating, setIsCreating] = useState(true);
    const [existingCampaign, setExistingCampaign] = useState();
    const [originalObject, setOriginalObject] = useState();
    const [targetAudience, setTargetAudience] = useState();
    const [basicCampaignInfo, setBasicCampaignInfo] = useState();
    const [refreshMatchers, setRefreshMatchers] = useState(0);
    const [externalSource, setExternalSource] = useState();

    useEffect(() => {
        GetExternalSource('J-ET').then((result) => {
            if (result) {
                setExternalSource(result);
            } else {
                addMessage({
                    message: window.translate('J-ET external source not found.  Please contact your administrator.'),
                    buttons: [
                        {
                            text: window.translate('Ok')
                        }
                    ]
                });
            }
        });

        const currentUser = { id: getClaimValue('ASId'), name: getClaimValue('fullName') };

        GetAll('revenueTypes').then((data) => {
            setRevenueTypes(data);

            const defaultType = data.find((x) => x.isDefault);

            GetBaseDemographic().then((demo) => {
                const basic = {
                    baseDemo: { id: demo.id, name: demo.name },
                    campaignOwner: currentUser,
                    salesExec: currentUser,
                    jetExec: currentUser,
                    revenueTypeId: defaultType.id
                };

                setBasicCampaignInfo(basic);
            });
        });
    }, []);

    const populateCampaignInfo = (info) => {
        const cmpInfo = {
            ...basicCampaignInfo,
            campaign: { id: info.existingCampaign.id, name: info.existingCampaign.name }
        };

        if (info.existingCampaign.agencyAccount) {
            cmpInfo.agency = { id: info.existingCampaign.agencyAccount.id, name: info.existingCampaign.agencyAccount.name }
        };

        if (info.existingCampaign.advertiserAccount) {
            cmpInfo.advertiser = { id: info.existingCampaign.advertiserAccount.id, name: info.existingCampaign.advertiserAccount.name }
        };

        if (info.existingCampaign.productCategory) {
            cmpInfo.category = { id: info.existingCampaign.productCategory.id, name: info.existingCampaign.productCategory.name }
        };

        if (info.existingCampaign.demographicId) {
            cmpInfo.targetAudience = targetAudience;
        };

        if (info.existingCampaign.campaignOwner) {
            cmpInfo.campaignOwner = { id: info.existingCampaign.campaignOwner.id, name: info.existingCampaign.campaignOwner.name }
        };

        if (info.existingCampaign.salesExec) {
            cmpInfo.salesExec = { id: info.existingCampaign.salesExec.id, name: info.existingCampaign.salesExec.name }
        };

        if (info.existingCampaign.jetExec) {
            cmpInfo.jetExec = { id: info.existingCampaign.jetExec.id, name: info.existingCampaign.jetExec.name }
        };

        if (info.existingCampaign.revenueTypeId) {
            cmpInfo.revenueTypeId = info.existingCampaign.revenueTypeId;
        };

        setCampaignInfo(cmpInfo);
    };

    const handleFileSelect = (file) => {
        setReadOnly(true);
        setRefreshMatchers(0);
        setOriginalObject();
        setTargetAudience();
        setExistingCampaign();

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            validate(reader.result).then((result) => {
                if (!result?.isValid) {
                    setValidationMessage(window.translate('File cannot be uploaded'));
                    const reasons = result.reasons.join(', ');

                    addMessage({
                        message: window.translate(`Rict validation failed for these reasons: ${reasons}`),
                        buttons: [
                            {
                                text: window.translate('Ok')
                            }
                        ]
                    });
                }
                else{
                    setOriginalObject(result);

                    if (result.existingCampaign !== null)
                    {
                        // Doing this here rather than further down because then isn't being awaited - hopefully this doesn't introduce a timing issue...
                        if (result.existingCampaign.demographicId) {
                            Get('demographic', result.existingCampaign.demographicId).then((data) => {
                                setTargetAudience({ id: data.id, name: data.name });
                            });
                        };

                        addMessage({
                            message: window.translate(`A campaign with JCN ${result.rictInfo.jcn} already exists. Do you want to replace with this new file?`),
                            buttons: [
                                {
                                    text: window.translate('Yes'),
                                    callback: () => {
                                        setIsCreating(false);
                                        setValidationMessage(`${file.name} ${window.translate('uploaded')}`)
                                        setRictFileInfo(result.rictInfo);
                                        setRictFile(result.rictFile);
                                        populateCampaignInfo(result);
                                        setExistingCampaign(result.existingCampaign);
                                        setReadOnly(false);
                                    }
                                },
                                {
                                    text: window.translate('No'),
                                    callback: () => setValidationMessage(window.translate('Campaign not loaded'))
                                }
                            ]
                        });
                    }
                    else{
                        setValidationMessage(`${file.name} ${window.translate('uploaded')}`)
                        setCampaignInfo(basicCampaignInfo);
                        setRictFileInfo(result.rictInfo);
                        setRictFile(result.rictFile);
                        setReadOnly(false);
                    }
                }
            });
        };
    };

    const handleClearClick = () => {
        setIsJetFileUpload(false);
        if (existingCampaign) {
            populateCampaignInfo(originalObject);
        } else {
            setCampaignInfo(basicCampaignInfo);
        }

        setRefreshMatchers(refreshMatchers + 1);
    };

    const handleClose = () => {
        setIsJetFileUpload(false);
        history.goBack();
    };

    const handleChange = (name, value) => {
        setCampaignInfo((prevState) => {
            // We need to do object comparison here not just a value
            if (JSON.stringify(prevState[name]) === JSON.stringify(value))
                return prevState;

            return {
                ...prevState,
                [name]: value
            };
        });
    };

    const handleAccountChange = (name, value) => {
        const cmpInfo = { [name]: value };
        if (!rictFileInfo.category && !campaignInfo.category && value.productCategoryId) {
            cmpInfo.category = { id: value.productCategoryId, name: value.productCategoryName };
        }
        setCampaignInfo((prevState) => {
            // We need to do object comparison here not just a value
            if (JSON.stringify(prevState[name]) === JSON.stringify(value))
                return prevState;

            return {
                ...prevState,
                ...cmpInfo
            };
        });
    };

    const handleAgencySearch = async () => {
        // Look to see if this already exists in the mapping table and return it if it does
        const mapping = await getMapping('Account', externalSource.id, rictFileInfo?.agency);
        if (mapping) {
            const agency = await GetAccountById(mapping.entityId);
            return [{ id: mapping.entityId, name: agency.accountName }];
        }

        return await accountSearch(rictFileInfo?.agency, 'agency');
    };

    const handleAdvertiserSearch = async () => {
        // Look to see if this already exists in the mapping table and return it if it does
        const mapping = await getMapping('Account', externalSource.id, rictFileInfo?.advertiser);
        if (mapping) {
            const advertiser = await GetAccountById(mapping.entityId);
            return [{ id: mapping.entityId, name: advertiser.accountName }];
        }

        return await accountSearch(rictFileInfo?.advertiser, 'advertiser');
    };

    const handleCategorySearch = async () => {
        // Look to see if this already exists in the mapping table and return it if it does
        const mapping = await getMapping('Category', externalSource.id, rictFileInfo?.category);
        if (mapping) {
            const category = await Get('productcategory', mapping.entityId);
            return [{ id: mapping.entityId, name: category.name }];
        }

        const data = await CategoriesLookup(rictFileInfo?.category, { pageNumber: 1, pageSize: -1, excludeInactive: true });
        return data?.data;
    };

    const handleBaseAudienceSearch = async () => {
        // Look to see if this already exists in the mapping table and return it if it does
        const mapping = await getMapping('Demographic', externalSource.id, rictFileInfo?.baseAudience);
        if (mapping) {
            const base = await Get('demographic', mapping.entityId);
            return [{ id: mapping.entityId, name: base.name }];
        }

        const data = await DemographicsLookup(rictFileInfo?.baseAudience, { pageNumber: 1, pageSize: -1 });
        return data?.data;
    };

    const handleTargetAudienceSearch = async () => {
        // Look to see if this already exists in the mapping table and return it if it does
        const mapping = await getMapping('Demographic', externalSource.id, rictFileInfo?.targetAudience);
        if (mapping) {
            const target = await Get('demographic', mapping.entityId);
            return [{ id: mapping.entityId, name: target.name }];
        }

        const data = await DemographicsLookup(rictFileInfo?.targetAudience, { pageNumber: 1, pageSize: -1 });
        return data?.data;
    };

    const handleCreateClick = () => {
        setIsJetFileUpload(false);
        importRict(rictFile.id, campaignInfo, rictFileInfo).then((campaignId) => {
            history.push({
                pathname: '/campaigns/details',
                state: {
                    campaignId: campaignId,
                    readOnly: true,
                    tabId: 0
                }
            });
        }).catch((error) => {
            addMessage({
                message: error.response.data.title,
                buttons: [
                    {
                        text: window.translate('Ok')
                    }
                ]
            })
        });
    };

    const handleExistingCampaignChange = (event) => {
        handleChange('campaign', { name: event.target.value });
    };

    const handleExistingCampaignDropdownClick = (searchResult) => {
        const { id, name } = searchResult;

        // They have chosen to link to an existing campaign so need to set that here
        // Also need to check if they are going to overwrite that campaign's JCN
        if (searchResult?.jcn && searchResult.jcn !== rictFileInfo.jcn)
        {
            addMessage({
                message: window.translate(`The selected campaign has JCN of ${searchResult.jcn} which is different to the imported JCN of ${rictFileInfo.jcn}. Do you really want to replace with this new file?`),
                buttons: [
                    {
                        text: window.translate('Yes'),
                        callback: () => {
                            setIsCreating(false);
                            handleChange('campaign', { id, name });
                        }
                    },
                    {
                        text: window.translate('No'),
                        callback: () => handleChange('campaign', { name })
                    }
                ]
            });
        } else {
            setIsCreating(false);
            handleChange('campaign', { id, name });
        }
    };

    const handleCampaignOwnerChange = (event) => {
        handleChange('campaignOwner', { name: event.target.value });
    };

    const handleCampaignOwnerDropdownClick = (searchResult) => {
        handleChange('campaignOwner', searchResult);
    };

    const handleSalesExecChange = (event) => {
        handleChange('salesExec', { name: event.target.value });
    };

    const handleSalesExecDropdownClick = (searchResult) => {
        handleChange('salesExec', searchResult);
    };

    const handleJetExecChange = (event) => {
        handleChange('jetExec', { name: event.target.value });
    };

    const handleJetExecDropdownClick = (searchResult) => {
        handleChange('jetExec', searchResult);
    };

    const handleRevenueTypeChange = (event) => {
        handleChange('revenueTypeId', event.target.value);
    };

    const canSave = () => {
        if (!campaignInfo.campaign) {
            return true;
        }

        if (campaignInfo.campaign && !('id' in campaignInfo.campaign)) {
            return false;
        }

        if (campaignInfo.campaign && ('id' in campaignInfo.campaign) && campaignInfo?.campaign?.id === window.emptyGuid) {
            return false;
        }

        return true;
    };

    return (
        <div style={{ width: '96%', marginLeft: '2%', marginRight: '2%', marginTop: 30 }}>
            <div style={{ ...panelStyle, justifyContent: 'space-between', alignItems: 'center', paddingLeft: '2%', paddingRight: '2%' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <FileUploadButton
                        style={{ ...buttonStyle, textAlign: 'center', margin: 'unset', marginRight: 30 }}
                        onFileSelect={handleFileSelect}
                        disabled={!externalSource}
                        isJetFileUpload={isJetFileUpload}
                    >
                        {window.translate('Upload file')}
                    </FileUploadButton>
                    <span>{validationMessage}</span>
                </div>
                <IconClose height={19} width={19} onClick={handleClose} />
            </div>
            <div style={{ ...panelStyle, justifyContent: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '60%' }}>
                    <span style={{ fontSize: 20, fontWeight: 500 }}>{window.translate('Campaign brief mapping')}</span>
                    <div style={{ display: 'flex', width: '100%', fontWeight: 500, marginBottom: 10 }}>
                        <span style={{ textAlign: 'center', flex: 1 }}>{window.translate('As received')}</span>

                        <span style={{ textAlign: 'center', flex: 1 }}>{window.translate('As used')}</span>
                    </div>
                    <div style={{ ...rowStyle, zIndex: 9 }}>
                        <AsText
                            id='rict-campaign'
                            title={window.translate('Campaign')}
                            labelStyle={labelStyle}
                            inputStyle={pageInputStyle}
                            value={rictFileInfo?.campaign}
                            disabled={true}
                        />
                        <div style={iconStyle}><IconArrow /></div>
                        <div style={{ width: '50%' }}>
                            <CompactTable
                                id='existing-campaign'
                                inputStyle={{ ...compactTableInputStyle, width: '85%'}}
                                buttonStyle={{ width: '15%'}}
                                value={campaignInfo?.campaign?.name ? campaignInfo?.campaign?.name : rictFileInfo?.campaign}
                                onChange={handleExistingCampaignChange}
                                searchFunction={(searchTerm, params) =>
                                    CampaignsLookup(searchTerm, params, [externalSource.id, window.emptyGuid])
                                }
                                tableColumnDefinitions={
                                    CampaignCompactTableColumnDefinitions
                                }
                                onDropdownClick={handleExistingCampaignDropdownClick}
                                disabled={readOnly || !rictFileInfo?.campaign || existingCampaign && campaignInfo.campaign?.id === existingCampaign?.id}
                            />
                        </div>

                    </div>
                    <div style={{ ...rowStyle, zIndex: 8 }}>
                        <AsText
                            id='rict-agency'
                            title={window.translate('Agency')}
                            labelStyle={labelStyle}
                            inputStyle={pageInputStyle}
                            value={rictFileInfo?.agency}
                            disabled={true}
                        />
                        <div style={iconStyle}><IconArrow /></div>
                        <EntityMatcher
                            id='campaign-agency'
                            name='agency'
                            searchText={rictFileInfo?.agency}
                            searchFunction={handleAgencySearch}
                            value={campaignInfo?.agency}
                            onChange={handleAccountChange}
                            containerStyle={{ width: '50%' }}
                            disabled={readOnly || !rictFileInfo?.agency}
                            forceRefresh={refreshMatchers}
                        />
                    </div>
                    <div style={{ ...rowStyle, zIndex: 7 }}>
                        <AsText
                            id='rict-advertiser'
                            title={window.translate('Advertiser')}
                            labelStyle={labelStyle}
                            inputStyle={pageInputStyle}
                            value={rictFileInfo?.advertiser}
                            disabled={true}
                        />
                        <div style={iconStyle}><IconArrow /></div>
                        <EntityMatcher
                            id='campaign-advertiser'
                            name='advertiser'
                            searchText={rictFileInfo?.advertiser}
                            searchFunction={handleAdvertiserSearch}
                            value={campaignInfo?.advertiser}
                            onChange={handleAccountChange}
                            containerStyle={{ width: '50%' }}
                            disabled={readOnly || !rictFileInfo?.advertiser}
                            forceRefresh={refreshMatchers}
                        />
                    </div>
                    <div style={{ ...rowStyle, zIndex: 6 }}>
                        <AsText
                            id='rict-category'
                            title={window.translate('Category')}
                            labelStyle={labelStyle}
                            inputStyle={pageInputStyle}
                            value={rictFileInfo?.category}
                            disabled={true}
                        />
                        <div style={iconStyle}><IconArrow /></div>
                        <EntityMatcher
                            id='campaign-category'
                            name='category'
                            searchText={rictFileInfo?.category}
                            searchFunction={handleCategorySearch}
                            value={campaignInfo?.category}
                            createNew={false}
                            onChange={handleChange}
                            containerStyle={{ width: '50%' }}
                            disabled={readOnly || !rictFileInfo?.category}
                            forceRefresh={refreshMatchers}
                        />
                    </div>
                    <div style={{ ...rowStyle, zIndex: 5 }}>
                        <AsText
                            id='rict-baseAudience'
                            title={window.translate('Base audience')}
                            labelStyle={labelStyle}
                            inputStyle={pageInputStyle}
                            value={rictFileInfo?.baseAudience}
                            disabled={true}
                        />
                        <div style={iconStyle}><IconArrow /></div>
                        <EntityMatcher
                            id='campaign-baseAudience'
                            name='baseAudience'
                            searchText={rictFileInfo?.baseAudience}
                            searchFunction={handleBaseAudienceSearch}
                            value={campaignInfo?.baseDemo}
                            createNew={false}
                            onChange={handleChange}
                            containerStyle={{ width: '50%' }}
                            disabled={true}
                            forceRefresh={refreshMatchers}
                        />
                    </div>
                    <div style={{ ...rowStyle, zIndex: 4 }}>
                        <AsText
                            id='rict-targetAudience'
                            title={window.translate('Target audience')}
                            labelStyle={labelStyle}
                            inputStyle={pageInputStyle}
                            value={rictFileInfo?.targetAudience}
                            disabled={true}
                        />
                        <div style={iconStyle}><IconArrow /></div>
                        <EntityMatcher
                            id='campaign-targetAudience'
                            name='targetAudience'
                            searchText={rictFileInfo?.targetAudience}
                            searchFunction={handleTargetAudienceSearch}
                            value={campaignInfo?.targetAudience}
                            createNew={false}
                            onChange={handleChange}
                            containerStyle={{ width: '50%' }}
                            disabled={readOnly || !rictFileInfo?.targetAudience}
                            forceRefresh={refreshMatchers}
                        />
                    </div>
                    <div style={rowStyle}>
                        <AsLabel
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                width: '8.5%',
                                marginRight: 15
                            }}>
                            {window.translate('Notes')}
                        </AsLabel>
                        <div style={{ width: '100%' }}>
                            <AsTextarea
                                id='rict-notes'
                                labelStyle={{ ...labelStyle, width: '8.7%' }}
                                inputStyle={{ ...pageInputStyle, width: '100%', height: 80 }}
                                value={rictFileInfo?.notes}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div style={{ ...rowStyle, zIndex: 3, alignItems: 'flex-end' }}>
                        <AsText
                            id='rict-jcn'
                            title={window.translate('JCN')}
                            labelStyle={{ ...labelStyle, alignItems: 'unset', alignSelf: 'center', paddingTop: 20 }}
                            inputStyle={pageInputStyle}
                            value={rictFileInfo?.jcn}
                            disabled={true}
                        />
                        <div style={iconStyle}></div>
                        <div style={{ width: '50%' }}>
                            <label style={lookupLabelStyle}>
                                {window.translate('Campaign owner')}
                            </label>
                            <CompactTable
                                id='campaign-owner'
                                inputStyle={{ ...compactTableInputStyle, width: '85%'}}
                                buttonStyle={{ width: '15%'}}
                                value={campaignInfo.campaignOwner?.name}
                                onChange={handleCampaignOwnerChange}
                                searchFunction={(searchTerm, params) =>
                                    UsersLookup(searchTerm, params)
                                }
                                tableColumnDefinitions={
                                    UserCompactTableColumnDefinitions
                                }
                                onDropdownClick={handleCampaignOwnerDropdownClick}
                                disabled={readOnly}
                            />
                        </div>
                    </div>
                    <div style={{ ...rowStyle, zIndex: 2, alignItems: 'flex-end' }}>
                        <AsText
                            id='rict-survey'
                            title={window.translate('Survey')}
                            labelStyle={{ ...labelStyle, alignItems: 'unset', alignSelf: 'center', paddingTop: 20 }}
                            inputStyle={pageInputStyle}
                            value={rictFileInfo?.survey}
                            disabled={true}
                        />
                        <div style={iconStyle}></div>
                        <div style={{ width: '50%' }}>
                            <label style={lookupLabelStyle}>
                                {window.translate('Sales Exec')}
                            </label>
                            <CompactTable
                                id='sales-exec'
                                inputStyle={{ ...compactTableInputStyle, width: '85%'}}
                                buttonStyle={{ width: '15%'}}
                                value={campaignInfo.salesExec?.name}
                                onChange={handleSalesExecChange}
                                searchFunction={(searchTerm, params) =>
                                    UsersLookup(searchTerm, params)
                                }
                                tableColumnDefinitions={
                                    UserCompactTableColumnDefinitions
                                }
                                onDropdownClick={handleSalesExecDropdownClick}
                                disabled={readOnly}
                            />
                        </div>
                    </div>
                    <div style={{ ...rowStyle, justifyContent: 'flex-end', zIndex: 1 }}>
                        <div style={{ width: '39%' }}>
                            <div style={{ width: '100%', marginBottom: 5 }}>
                                <label style={lookupLabelStyle}>
                                    {window.translate('J-ET Exec')}
                                </label>
                                <CompactTable
                                    id='jet-exec'
                                    inputStyle={{ ...compactTableInputStyle, width: '85%'}}
                                    buttonStyle={{ width: '15%'}}
                                    value={campaignInfo.jetExec?.name}
                                    onChange={handleJetExecChange}
                                    searchFunction={(searchTerm, params) =>
                                        UsersLookup(searchTerm, params)
                                    }
                                    tableColumnDefinitions={
                                        UserCompactTableColumnDefinitions
                                    }
                                    onDropdownClick={handleJetExecDropdownClick}
                                    disabled={readOnly}
                                />
                            </div>
                            <AsSelectWithPlaceholder
                                id='revenue-type'
                                title={window.translate('Revenue Type')}
                                values={revenueTypes}
                                value={campaignInfo.revenueTypeId}
                                onChange={handleRevenueTypeChange}
                                disabled={readOnly}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ ...panelStyle, justifyContent: 'flex-end', paddingRight: '2%' }}>
                <AsButton
                    useTertiaryStyle
                    handleClick={handleClearClick}
                    style={{ ...buttonStyle, marginRight: '2%' }}
                    disabled={readOnly}
                >
                    {window.translate('Clear')}
                </AsButton>
                <AsButton
                    style={buttonStyle}
                    handleClick={handleCreateClick}
                    disabled={readOnly || !canSave()}
                >
                    {window.translate(isCreating ? 'Create campaign' : 'Update campaign')}
                </AsButton>
            </div>
        </div>
    );
};

export default JetImportPage;
